import axios from 'axios';
import { TTP_API_URL } from 'Config';
import { getRankingOptions } from 'TamtamAPI';

export const getRankingClients = (token, instanceId, data) => {
  const requestUrl = `${TTP_API_URL}/survey/ranking/clients`;
  const {
    pageSize, paginationPage, country, city, clientName, sortConfig, organizationId,
  } = data;
  const filter = [];
  const sort = [];

  if (instanceId != null) {
    filter.push({
      property: 'instance.id',
      value: instanceId,
      operator: 'eq',
    });
  }
  if (country != null && country !== 'all') {
    filter.push({
      property: 'client.country',
      value: country,
      operator: 'eq',
    });
  }
  if (city != null && city !== 'all') {
    filter.push({
      property: 'client.city',
      value: city,
      operator: 'eq',
    });
  }
  if (clientName) {
    filter.push({
      property: 'client.name',
      value: clientName,
      operator: 'like',
    });
  }
  if (organizationId) {
    filter.push({
      property: 'organization',
      value: organizationId,
      operator: 'eq',
    });
  }

  if (sortConfig) {
    sort.push({
      property: sortConfig.columnKey,
      dir: sortConfig.sortDirection,
    });
  }

  const params = {
    access_token: token,
    limit: pageSize || 10,
    start: (!paginationPage) ? 0 : ((paginationPage - 1) * pageSize),
  };

  params.filter = JSON.stringify(filter);
  params.sort = JSON.stringify(sort);

  return axios.get(requestUrl, { params });
};

export const getRankingClientsOptions = token => getRankingOptions(token);
